import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'

interface submitFormProps {
  customer_id: number
  setShowOverlay: Function
}

const processCustomerChange = async (props: submitFormProps) => {
  const payload = {
    customer_id: props.customer_id,
  }
  return await axiosPut(apiUrls.users + '/' + apiUrls.actionChangeCustomer, payload, () => {})
}

export default processCustomerChange
